import React from 'react'

import api from '../services/api'
import locale from '../services/locale'
import { formatDate } from '../services/helpers'

import '../stylesheets/pages/Account.scss'

export default class Account extends React.Component {
    state = {
        data: null,
    }
    handleTerminate = async () => {
        this.props.history.push('/feedback')
    }
    componentDidMount = async () => {
        const response = await api.account()
        const data = response.data
        this.setState({ data })
    }
    render() {
        return this.state.data ? (
            <div className="Account">
                <div className="Account_window">
                    <ul>
                        <li>
                            <span>{locale.translate(`account_user_key`)}</span>:{' '}
                            {this.state.data.email}
                        </li>
                        {this.state.data.customer ? (
                            <>
                                {this.state.data.customer.subscriptionType && (
                                    <li>
                                        <span>{locale.translate(`account_subscription_key`)}</span>:{' '}
                                        {locale.translate(
                                            `account_subscription_value_${this.state.data.customer.subscriptionType}_${this.state.data.customer.subscriptionCycle}`,
                                        )}
                                    </li>
                                )}
                                <li>
                                    <span>{locale.translate(`account_status_key`)}</span>:{' '}
                                    {locale.translate(
                                        `account_status_value_${
                                            !this.state.data.customer.terminate * 1
                                        }`,
                                    )}
                                </li>
                                {this.state.data.customer.subscriptionCycle && (
                                    <li>
                                        <span>
                                            {locale.translate(
                                                `account_cycle_key_${
                                                    !this.state.data.customer.terminate * 1
                                                }`,
                                            )}
                                        </span>
                                        : {formatDate(this.state.data.renewal)}
                                    </li>
                                )}
                            </>
                        ) : (
                            <li>
                                <span>{locale.translate(`account_subscription_key`)}</span>:{' '}
                                {locale.translate(`account_subscription_value_none`)}
                            </li>
                        )}
                    </ul>
                    {this.state.data.customer &&
                        this.state.data.customer.subscriptionType === 'recurring' &&
                        !this.state.data.customer.terminate && (
                            <button onClick={this.handleTerminate}>
                                {locale.translate(`account_terminate`)}
                            </button>
                        )}
                </div>
            </div>
        ) : null
    }
}
